import flatten from "ramda/src/flatten"
import keys from "ramda/src/keys"
import toPairs from "ramda/src/toPairs"

import availableFonts from "@izettle/web-brand/lib/fonts"
import icons from "@izettle/web-brand/lib/icons"

const allFonts = { ...availableFonts, ...{ dingbatz: icons.dingbatz.font } }

export const fontWeights = {
  zent: {
    // light: "300", // Available but not in use.
    regular: "400",
    medium: "500",
    bold: "600",
    // "extra-bold": "800", // Available but not in use.
  },
  tiempos: {
    // "semi-bold": "normal", // Available but not in use.
  },
  dingbatz: {
    light: "300",
    // regular: "400", // Available but not in use.
  },
}

const loadFont = ({ name, weight }) =>
  [
    "@font-face{font-family:",
    allFonts[name].name,
    ";font-weight:",
    allFonts[name].fonts[weight].weight,
    ';src:url("',
    allFonts[name].fonts[weight].file,
    '") format("woff")}',
  ].join("")

export const fontsToLoad = flatten(
  toPairs(fontWeights).map(([name, weights]) =>
    keys(weights).map((weight) => ({ name, weight })),
  ),
)
  .map(loadFont)
  .join("\n")

export const makeFontRule = (name, weight, size, lineHeight) => {
  const font = allFonts[name]
  const props = [
    font.fonts[weight].weight,
    `${size}/${lineHeight}`,
    `${[font.name].concat(font.fallbacks).join(",")}`,
  ].join(" ")
  return `font:${props};`
}

export const defaultFont = makeFontRule("zent", "medium", "14px", "1.5")
